import { WHATSAPP_DISPLAY, whatsappLink } from "@/constants/site";

export default function WhatsAppFloat() {
  return (
    <a
      href={whatsappLink()}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={`Falar no WhatsApp ${WHATSAPP_DISPLAY}`}
      className="group fixed bottom-5 right-5 z-50 flex items-center gap-3 rounded-full bg-secondary-500 py-3 pl-3 pr-3 md:pr-5 text-background-50 shadow-lg transition-all hover:bg-secondary-600"
    >
      <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50/20">
        <i className="ri-whatsapp-line text-2xl" aria-hidden="true"></i>
      </span>
      <span className="hidden md:flex flex-col leading-tight">
        <span className="text-[11px] font-medium uppercase tracking-wide text-background-50/80">
          WhatsApp
        </span>
        <span className="text-sm font-semibold whitespace-nowrap">{WHATSAPP_DISPLAY}</span>
      </span>
    </a>
  );
}